import { render, staticRenderFns } from "./CallCallList.vue?vue&type=template&id=da9942ba&scoped=true"
import script from "./CallCallList.vue?vue&type=script&lang=js"
export * from "./CallCallList.vue?vue&type=script&lang=js"
import style0 from "./CallCallList.vue?vue&type=style&index=0&id=da9942ba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9942ba",
  null
  
)

export default component.exports